import React, { useState } from 'react';

interface CommentInputProps {
    onSubmit: (content: string) => Promise<void>;
    placeholder?: string;
    maxLength?: number;
    initialValue?: string;
    buttonLabel?: string;
}

const CommentInput: React.FC<CommentInputProps> = ({
    onSubmit,
    placeholder = "댓글을 남겨보세요...",
    maxLength = 500,
    initialValue = "",
    buttonLabel = "등록"
}) => {
    const [content, setContent] = useState(initialValue);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        if (text.length <= maxLength) setContent(text);
    };

    const handleSubmit = async () => {
        if (!content.trim()) return;
        setIsSubmitting(true);
        try {
            await onSubmit(content);
            setContent("");
        } catch (error) {
            console.error("Failed to submit comment", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            handleSubmit();
        }
    };

    return (
        <div className="w-full flex flex-col gap-2">
            <textarea
                className="w-full h-[100px] border border-[#d1d5db] rounded-[8px] px-4 py-[17px] resize-none outline-none text-[16px] text-[#1f2937] placeholder-[#9ca3af] leading-relaxed focus:border-[#19cf7a] transition-colors"
                placeholder={placeholder}
                value={content}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={isSubmitting}
            />
            <div className="flex justify-end">
                <button
                    onClick={handleSubmit}
                    disabled={!content.trim() || isSubmitting}
                    className={`rounded-[30px] px-5 py-2 text-[13px] md:px-9 md:py-[13px] md:text-[14px] font-medium tracking-wide transition-all ${
                        content.trim() && !isSubmitting
                            ? 'bg-[#19cf7a] text-white hover:bg-[#00b368]'
                            : 'bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed'
                    }`}
                >
                    {isSubmitting ? '등록 중...' : buttonLabel}
                </button>
            </div>
        </div>
    );
};

export default CommentInput;
